import React, { useEffect, useState, useRef } from "react"
import { Container } from "react-bootstrap"
import ChatInterface from "./components/chat-interface"
import SuggestionsModal from "../../../components/SuggestionsModal/index.js"
import VeeLogo from "./assets/vlogo.jsx"
import "./App.css"
import { SuggestionsContext } from "./SuggestionsContext.js"

export default function ChatBotView() {
  const [messages, setMessages] = useState([])
  const [newMessage, setNewMessage] = useState("")
  const [typing, setTyping] = useState(false)
  const [chatVisible, setChatVisible] = useState(true)
  const [threadId, setThreadId] = useState("")
  const [showGreeting, setShowGreeting] = useState(true)
  const [isHovered, setIsHovered] = useState(false)
  const [functionsSuggesteds, setFunctionsSuggesteds] = useState([])
  const [loadingSuggestions, setLoadingSuggestions] = useState(true)

  // Inicializa a mensagem de boas-vindas
  useEffect(() => {
    // Inicializa a mensagem de boas-vindas se não houver mensagens
    if (messages.length === 0) {
      const welcomeMessage = {
        id: Date.now().toString(),
        content: "Olá, eu sou a Vee e vou te ajudar aqui no Convert! O que você precisa exatamente?",
        sender: "assistant",
        timestamp: new Date(),
        reactions: { copied: false, liked: false, disliked: false },
      }
      setMessages([welcomeMessage])
    }

    // Timer para esconder a mensagem de boas-vindas ao passar o mouse
    const timer = setTimeout(() => {
      setShowGreeting(false)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])


  useEffect(() => {
    setThreadId(window.crypto.randomUUID())

    const functionsParam = { "funcoes": true };

    setLoadingSuggestions(true)

    handleServiceChatbotApi(functionsParam)
    .then((data) => {
      setFunctionsSuggesteds(data[0].funcionalidades || []);
    })
    .catch((error) => {
      console.error("Erro na chamada:", error);
    }).finally(() => {
      setLoadingSuggestions(false)
    })
  }, [])

  // Eventos para mostrar/esconder a mensagem quando o mouse passa pelo logo
  const handleMouseEnter = () => {
    setIsHovered(true)
    setShowGreeting(true)
  }

  const handleMouseLeave = () => {
    setIsHovered(false)
    setShowGreeting(false)
  }

  const handleServiceChatbotApi = async (message) => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), 300000);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_N8N_IA_AGENTE_URL}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": `${process.env.REACT_APP_N8N_IA_AGENTE_TOKEN}`,
          },
          body: JSON.stringify(message),
          signal: controller.signal,
        }
      ).finally(() => clearTimeout(id))
      return await response.json()
    } catch (error) {
      console.error("Erro ao chamar a API:", error)
      throw error
    }
  }

  // Processa a mensagem do usuário
  const handleSendMessage = async (e) => {
    e.preventDefault()
    if (newMessage.trim() === "") return

    const userMessage = {
      id: Date.now().toString(),
      content: newMessage,
      sender: "user",
      timestamp: new Date(),
      reactions: { copied: false, liked: false, disliked: false },
    }

    setMessages((prev) => [...prev, userMessage])
    setNewMessage("")
    setTyping(true)

    // Processa a mensagem para a API
    try {
      const message = {
        sessionId: threadId,
        mensagem: newMessage,
      }

      const data = await handleServiceChatbotApi(message);

      const assistantMessage = {
        id: (Date.now() + 1).toString(),
        content: data[0].output,
        sender: "assistant",
        timestamp: new Date(),
        reactions: { copied: false, liked: false, disliked: false },
      }

      setMessages((prev) => [...prev, assistantMessage])
    } catch (error) {
      console.error("Erro ao enviar mensagem:", error)
      // Resposta de fallback em caso de erro
      const fallbackMessage = {
        id: (Date.now() + 1).toString(),
        content: "Desculpe, estou enfrentando problemas de conexão. Pode tentar novamente mais tarde?",
        sender: "assistant",
        timestamp: new Date(),
        reactions: { copied: false, liked: false, disliked: false },
      }
      setMessages((prev) => [...prev, fallbackMessage])
    } finally {
      setTyping(false)
    }
  }

  const handleSuggestionClick = (suggestion) => {
    setNewMessage(suggestion); 
  };

  const [isDoubtsModalOpen, setIsDoubtsModalOpen] = useState(false);

  return (
    <>
    <SuggestionsContext.Provider value={{ isOpen: isDoubtsModalOpen, setIsOpen: setIsDoubtsModalOpen }}>

      <SuggestionsModal data={functionsSuggesteds} onSuggestionClick={handleSuggestionClick} loading={loadingSuggestions} />
      {!chatVisible ? (
        <div
          className="logoIaChat"
          onClick={() => setChatVisible(true)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <VeeLogo className={`${isHovered ? 'hovered' : ''}`} />
          {showGreeting && (
            <div className="messageVee">
              <p>Olá, sou a Vee e estou aqui pra te ajudar!</p>
            </div>
          )}
        </div>
      ) : (
        <Container fluid className="p-0 min-vh-100 text-white d-flex justify-content-center main-container" style={{ backgroundColor: "#fff !important" }}>
          <div className="chat-container">
            <ChatInterface
              messages={messages}
              newMessage={newMessage}
              setNewMessage={setNewMessage}
              handleSendMessage={handleSendMessage}
              typing={typing}
            />
          </div>
        </Container>
      )}
    </SuggestionsContext.Provider>

    </>
  )
}

